import React from 'react';

/** ****************************** COMPONENTS  *********************88 */
import Card from 'components/Cards/Card';
import FilterSearchBar from '../User/components/FilterSearchBar';
import CustomPaginationTable from 'components/Table/CustomPaginationTable';

/** ****************************** HELPERS AND APIES  ********************** */
import { allcompaniesHeader } from 'components/Table/Headers/Company/companyTableHeader';
import { useLazyGetAllCompaniesQuery } from 'reducers/company.service';
import { Box,SimpleGrid, Select } from '@chakra-ui/react';
import { useSearchParamsHook } from 'hooks';
const Allcompany = () => {
    const [getAllCompanies, { data, isLoading, isError }] = useLazyGetAllCompaniesQuery();
    const [recentquery, setrecentquery] = React.useState({});
    const [searchparams , setSearchParams] = useSearchParamsHook();
    const isApprovedByAdmin = searchparams.get('isApprovedByAdmin');

    const refetch = ()=>{
        getAllCompanies(recentquery).unwrap();
    };

    const companyTableHeader = allcompaniesHeader({ tableActions: [] });
    const handlePageChange = (query)=>{
        setrecentquery(query);
        return getAllCompanies(query).unwrap();
    };
    const handleStatusChange = (e)=>{
        let { name, value } = e.target;
        setSearchParams(name , value);
    };

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <SimpleGrid
                mb="20px"
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
            >
                <Card>
                    <FilterSearchBar
                        onRefresh={refetch}
                        isPercentage={ true}
                        isDateFilter={true}
                        isStatus={false}
                        downloadType={'ORGANIZATION'}
                    >
                        <Select
                            placeholder="Status (All)"
                            fontWeight="semibold"
                            size="sm"
                            w="150px"
                            name={'isApprovedByAdmin'}
                            onChange={handleStatusChange}
                            value={isApprovedByAdmin}
                        >
                            <option value="true">Active</option>
                            <option value="false">Block</option>
                        </Select>

                    </FilterSearchBar>

                    <div className="page-main-box">
                        <CustomPaginationTable
                            {...data}
                            handlePageChange={handlePageChange}
                            handleRefresh={refetch}
                            columns={companyTableHeader}
                            isLoading={isLoading}
                            isError={isError}
                        />
                        {/* <CustomTable
                        handleRefresh={refetch}
                        data={data}
                        columns={companyTableHeader}
                        isLoading={isLoading}
                        isError={isError}
                        defaultSorted={[{ dataField: 'status',order: 'asc' }]}
                        key="_id"
                    /> */}
                    </div>
                </Card>
            </SimpleGrid>
        </Box>
    );
};

export default Allcompany;
